import Modal from 'components/Modal/Modal'
import { Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { SlotSchema } from 'lib/utils'
import { SlotContent } from './SlotContent'

export type ValueProps = {
  date: Date | null
  startTime: Date | null
  endTime: Date | null
  orderQuota: string
  graceHours: string
  feeProducts: string
  deliveryFee: string
  visibilityStart: Date | null
  visibilityEnd: Date | null
  active: boolean
  recurrent: boolean
  validityStart: Date | null
  validityEnd: Date | null
  attributes?: boolean
}

type NewSlotModalProps = {
  isLoading: boolean
  handleSubmit: (values: ValueProps) => void
  modal: { right: boolean }
  handleCloseModal: () => void
  startTime: Date | null
  endTime: Date | null
  deliverySlot?: boolean
}

export const NewSlotModal = ({
  handleCloseModal,
  isLoading,
  handleSubmit,
  modal,
  startTime,
  endTime,
  deliverySlot,
}: NewSlotModalProps) => {
  const { t } = useTranslation()

  const initialValues = {
    date: startTime,
    startTime,
    endTime,
    orderQuota: '',
    graceHours: '',
    feeProducts: '',
    deliveryFee: '',
    visibilityStart: null,
    visibilityEnd: null,
    active: true,
    recurrent: false,
    validityStart: startTime,
    validityEnd: null,
    attributes: false,
  }

  if (!startTime || !endTime) return null
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={SlotSchema}
      onSubmit={async (values) => handleSubmit(values)}>
      {({ isValid, dirty, submitForm }) => (
        <Modal
          showButton
          onButtonClick={submitForm}
          buttonIsDisabled={!isValid || !dirty}
          setModal={handleCloseModal}
          modal={modal}
          buttonText={t('serviceArea.addSlot')}
          isLoadingRequest={isLoading}
          title={t('serviceArea.newSlot')}>
          <SlotContent deliverySlot={deliverySlot} />
        </Modal>
      )}
    </Formik>
  )
}
